import { CONTACTS } from "constants/action-types";
import { stringify } from "querystring";
import { IBuyer, ICompany } from "components/contacts/contacts-types";
import { IHeader } from "constants/table-types";
import me from "models/me";

export function fetchContacts(params, next) {
    return (dispatch, getState) => {
        const { nextPage } = getState().contacts.accounts;
        if (next && !nextPage) {
            return;
        }
        let url = nextPage;
        if (!next || !url) {
            const { filters, search, searchField, sort, sortOrder, page_limit } = params;
            const query = {
                __search: search,
                __search_field: searchField || "",
                __fields: "__all",
                __limit: page_limit ?? 50,
                __sort: `__${sort}`, // todo: temporary before fixing helpers
                __sort_order: sortOrder,
                brand: params.brand,
                ...filters.toJS(),
            };
            url = `/api/v3.0/companies/contacts?${stringify(query)}`;
        }
        if (!next) {
            dispatch({ type: CONTACTS.ACCOUNTS.UPDATE, payload: [] });
        }
        dispatch({ type: CONTACTS.ACCOUNTS.FETCH.START, payload: { url, next } });
    };
}

export const updateContacts = (newContacts) => ({
    type: CONTACTS.ACCOUNTS.UPDATE,
    payload: newContacts,
});

export const fetchBuyer = (buyerId: string) => ({
    type: CONTACTS.BUYER.FETCH.START,
    payload: { url: `/api/v3.0/companies/contacts/${buyerId}` },
});

export const fetchCompany = (companyId: string, brandId?: string) => ({
    type: CONTACTS.COMPANY.FETCH.START,
    payload: { url: `/api/v3.1/company/${companyId}` + (brandId ? `?brand=${brandId}` : "") },
});

export const deleteBuyer = (companyId: string, buyerRef: string, redirect = true) => ({
    type: CONTACTS.BUYER.DELETE,
    payload: { url: `/company/${companyId}/remove/user/${buyerRef}`, redirect, meta: { contact: companyId } },
});

export const deleteCompany = (companyId: string, redirect = true) => ({
    type: CONTACTS.COMPANY.DELETE,
    payload: { url: `/company/remove/${companyId}`, redirect },
});

export const createCompany = (body: Partial<IBuyer>) => ({
    type: CONTACTS.COMPANY.CREATE,
    payload: { url: "/company/new", body },
});

export const createBuyer = (companyId: string, body: Partial<IBuyer>, onSuccess?: () => void) => ({
    type: CONTACTS.BUYER.CREATE,
    payload: { url: `/company/${companyId}/attach/user`, body },
    meta: { onSuccess },
});

export const editBuyer = (companyId: string, body: Partial<IBuyer>) => ({
    type: CONTACTS.BUYER.UPDATE.START,
    payload: { url: `/company/${companyId}/update/user/${body.ref}`, body, meta: { company: companyId } },
});

export const editCompany = (body: Partial<ICompany>) => ({
    type: CONTACTS.COMPANY.UPDATE.START,
    payload: { url: `/api/v3.0/companies/update/${body._id}`, body },
});

export const generateKeys = (companyId: string) => ({
    type: CONTACTS.COMPANY.API.GENERATE_KEYS,
    payload: { url: `/company/api/generate/keys/${companyId}` },
});

export const getCompanyApi = (companyId: string) => ({
    type: CONTACTS.COMPANY.API.GET,
    payload: { url: `/api/v3.1/company/${companyId}` },
});

export const approveApp = (companyId: string, appId: string) => ({
    type: CONTACTS.COMPANY.API.APPROVE,
    payload: { url: `/company/api/application/approve/${companyId}/${appId}`, companyId },
});

export const disableApp = (companyId: string, appId: string) => ({
    type: CONTACTS.COMPANY.API.DISABLE,
    payload: { url: `/company/api/application/disable/${companyId}/${appId}` },
});

export const fetchHeaders = () => ({
    type: CONTACTS.HEADERS.FETCH.START,
    payload: { url: `/api/v3.0/user/${me._id}/table-view-fields/contacts` },
});

export const updateHeaders = (fields: IHeader[]) => ({
    type: CONTACTS.HEADERS.UPDATE,
    payload: { url: `/api/v3.0/user/${me._id}/table-view-fields/contacts`, body: fields },
});
